import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { L1AuthGuard, L3AuthGuard } from 'ngx-auth-util-lib';
import { NoAppAccessComponent } from './components/no-app-permission/no-app-access.component';
import { OauthComponent } from './components/oauth/oauth.component';
import { SanctionedCompanyComponent } from './components/sanctioned-company/sanctioned-company.component';
import { NoAppAccessGuard } from './guards/no-app-access-guard.service';
import { SanctionedCompanyGuard } from './guards/sanctioned-company-guard.service';
import { MultiDomainMgmtComponent } from './multi-domain-mgmt/multi-domain-mgmt.component';
import { OnboardingGuard } from './guards/onboarding-guard.service';
import { multiDomainMgmtRoute } from './models/multi-domain';
import { titleResolver } from './resolvers/title.resolver';

const routes: Routes = [
  {
    path: 'oauth',
    component: OauthComponent
  },
  {
    path: 'no-app-access',
    component: NoAppAccessComponent,
    canActivate: [NoAppAccessGuard]
  },
  {
    path: 'company-check',
    component: SanctionedCompanyComponent,
    canActivate: [SanctionedCompanyGuard]
  },
  {
    path: multiDomainMgmtRoute,
    component: MultiDomainMgmtComponent,
    canActivate: [L1AuthGuard],
    resolve: { title: titleResolver },
    data: {
      titleKey: 'multiDomainMgmt'
    },
  },
  {
    path: 'pages',
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
    canActivate: [L1AuthGuard, L3AuthGuard]
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./onboarding/onboarding.module').then(m => m.OnboardingModule),
    canActivate: [L1AuthGuard, OnboardingGuard]
  },
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  { path: '**', redirectTo: 'pages' }
];

const config: ExtraOptions = {
  useHash: false,
  scrollPositionRestoration: 'enabled',
  paramsInheritanceStrategy: 'always' //TODO keep eye on
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
